let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dKSPa")).then(() => parcelRequire('aEN3l'));